import { makeStyles, createStyles, Theme, Box, Typography } from "@material-ui/core";
import EmptyStateImage from "./emptyState";

export type EmptyStateProps = {
  title: string;
  subtitle: string;
};

export const EmptyState = ({ title, subtitle }: EmptyStateProps) => {
  const classes = useStyles();

  return (
    <Box padding="89px 55px 0" display="flex" alignItems="center" flexDirection="column">
      <EmptyStateImage />
      <Typography className={classes.title}>{title}</Typography>
      <Typography className={classes.subtitle}>{subtitle}</Typography>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      fontSize: 18,
      fontWeight: "normal",
      lineHeight: 1.33,
      textAlign: "center",
      color: theme.palette.dark.main,
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    subtitle: {
      fontSize: 16,
      fontWeight: "normal",
      lineHeight: "normal",
      textAlign: "center",
      color: theme.palette.battleshipGrey.main,
    },
  }),
);
